import { ActionReducerMap, createFeatureSelector } from '@ngrx/store';
import * as fromAudit from './audit.reducer';

export const reducers: ActionReducerMap<any> = {
  data: fromAudit.reducer,
};

export const getAuditItem = createFeatureSelector<any>('Audit');
